var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.985 4h-17.97a8.01 8.01 0 0 0-8 8v2.917a1 1 0 1 0 2 0V12a6.007 6.007 0 0 1 6-6h17.97a6.007 6.007 0 0 1 6 6v37.993h-29.97V45.37a1 1 0 0 0-2 0V52a8.01 8.01 0 0 0 8 8h17.97a8.01 8.01 0 0 0 8-8V12a8.01 8.01 0 0 0-8-8zm6 48a6.007 6.007 0 0 1-6 6h-17.97a6.007 6.007 0 0 1-6-6v-.007h29.97z",
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 55.79h5a1 1 0 0 0 0-2h-5a1 1 0 0 0 0 2zM12.312 15.917h3.332l3.615 14.454h-.777a3.057 3.057 0 0 0 0 6.114h18.512a1 1 0 0 0 0-2H18.482a1.057 1.057 0 0 1 0-2.114h17.03a3.053 3.053 0 0 0 2.9-2.09l2.742-8.227a3.058 3.058 0 0 0-2.9-4.024h-20.02l-.838-3.355a1 1 0 0 0-.97-.758h-4.114a1 1 0 0 0 0 2zm25.942 4.113a1.058 1.058 0 0 1 1.003 1.392l-2.742 8.226a1.056 1.056 0 0 1-1.003.723H21.319l-2.585-10.34zM18.533 36.772a3.286 3.286 0 1 0 3.285 3.287 3.29 3.29 0 0 0-3.285-3.287zm0 4.572a1.286 1.286 0 1 1 1.285-1.285 1.287 1.287 0 0 1-1.285 1.285zM34.533 36.772a3.286 3.286 0 1 0 3.285 3.287 3.29 3.29 0 0 0-3.285-3.287zm0 4.572a1.286 1.286 0 1 1 1.285-1.285 1.287 1.287 0 0 1-1.285 1.285zM6.16 21h4.92a1 1 0 1 0 0-2H6.16a1 1 0 1 0 0 2z",
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16 25h6.967a1 1 0 0 0 0-2H6.159a1 1 0 1 0 0 2zM17 28a1 1 0 0 0-1-1H6.16a1 1 0 1 0 0 2H16a1 1 0 0 0 1-1z",
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcom);
export default __webpack_public_path__ + "static/media/ecom.ab0b2d8ecb2a6593771dfa4378ac5754.svg";
export { ForwardRef as ReactComponent };